import cn from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var SubmenuOption = function SubmenuOption(_ref) {
  var category = _ref.category,
    label = _ref.label,
    selected = _ref.selected,
    onClick = _ref.onClick,
    isLast = _ref.isLast;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: cn('bg-transparent focus:outline-none px-8', selected ? 'font-subtitle3 text-secondary-light' : 'font-body3 text-white', {
      'mb-24': !isLast
    }),
    style: {
      lineHeight: '24px'
    },
    "aria-label": category ? "".concat(category, " ").concat(label) : label,
    onClick: onClick,
    children: label
  });
};
export default SubmenuOption;